'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { signIn } from 'next-auth/react';
import { useTranslations } from 'next-intl';
import { useForm } from 'react-hook-form';
import z from 'zod';

import { cn } from '@/utils/helpers';

import { TextInput } from '../TextInput';
import { AuthForm as AuthFormType } from './AuthModal.types';

export default function AuthForm() {
  const t = useTranslations('auth');
  const {
    handleSubmit,
    formState: { isValid },
    register,
  } = useForm<AuthFormType>({
    resolver: zodResolver(
      z.object({
        username: z.string().min(4, { message: t('validation.usernameMinLength') }),
        password: z.string().min(6, { message: t('validation.passwordMinLength') }),
      }),
    ),
  });

  const onSubmit = (data: AuthFormType) =>
    signIn('credentials', { email: data.username, password: data.password });

  return (
    <div className="card bg-base-100 w-full max-w-sm shrink-0">
      <div className="card-body p-0!">
        <form className="fieldset" onSubmit={handleSubmit(onSubmit)}>
          <TextInput label={t('username')} placeholder={t('username')} {...register('username')} />
          <TextInput
            label={t('password')}
            placeholder={t('password')}
            type="password"
            {...register('password')}
          />
          <button
            disabled={!isValid}
            type="submit"
            className={cn(
              'bg-red-polar w-full cursor-pointer rounded-lg! px-5 py-2 leading-[120%]',
              'mt-2 text-base font-[520] text-white disabled:opacity-50',
            )}>
            {t('submit')}
          </button>
        </form>
      </div>
    </div>
  );
}
